import {
  getFaqs
} from '~api/faqs'

export const state = () => ({
  faqs: [],
  pages: {}
})

export const getters = {
  faqsGetter: state => state.faqs,
  pageGetter: state => state.pages
}

export const actions = {
  async getFaqs ({ commit }, page) {
    const data = await getFaqs(page)
    const {
      faqs,
      pages
    } = data

    commit('setFaqs', faqs)
    commit('setFaqsPage', pages)

    return data
  }
}

export const mutations = {
  setFaqs (state, payload) {
    state.faqs = payload
  },
  setFaqsPage (state, payload) {
    state.pages = payload
  }
}
